/**
 * getter方法，获取数据
 */
// App还是浏览器打开的项目'app' 'browser';
export const menuList = state => state.menuList;
export const authorities = state => state.authorities;



// WEBPACK FOOTER //
// ./src/store/getters.js